module.exports = __webpack_public_path__ + "img/victor.fa00608e.png";